import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { Person_Interface } from 'src/app/Interface/Person_Interface';
import { QUANTITY_Interface } from 'src/app/Interface/QUANTITY_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QUANTITYService {

  constructor(private http:HttpClient) { }

  GetRecord1(Token:String,id:number):Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Quantity?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  GetTree(Token:String):Observable<Array<QUANTITY_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Quantity/GetTree?token="+Token).pipe(
      map(data=>{
        return data as Array<QUANTITY_Interface>
      })
    )
  }

  GetActive(Token:String):Observable<Array<QUANTITY_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Quantity/Getactive?token="+Token).pipe(
      map(data=>{
        return data as Array<QUANTITY_Interface>
      })
    )
  }

  GetActiveParent(Token:String):Observable<Array<QUANTITY_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Quantity/Getactiveparent?token="+Token).pipe(
      map(data=>{
        return data as Array<QUANTITY_Interface>
      })
    )
  }


  EditAddQUANTITY(model: QUANTITY_Interface,Token:String):Observable<QUANTITY_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      certificate_id:model.certificate_id,
      dataentity_id:model.dataentity_id,
      parent:model.parent,
      del:false,
      username:Token,
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/Quantity/AddEdit",body,{headers}).pipe(
        map(data=>{
          return data as QUANTITY_Interface
        })
      )

  }

  DeleteQUANTITY(id:number,Token:String):Observable<QUANTITY_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/Quantity/Delete?id="+id+"&token="+Token).pipe(
        map(data=>{
          return data as QUANTITY_Interface
        })
      )
  }

  DomainQUANTITY(id:number,Token:String):Observable<QUANTITY_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/Quantity/Doamin?id="+id+"&token="+Token).pipe(
        map(data=>{
          return data as QUANTITY_Interface
        })
      )
  }


  GetController(Token:String,id:number):Observable<Array<Person_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Quantity/GetController?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as Array<Person_Interface>
      })
    )
  }

  PostController(
    quantity_id: number,
    Token: String,
    persone_id: number): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      token: Token,
      quantity_id: quantity_id,
      persone_id: persone_id,
    }


    return this.http.post(environment.BaseUrl + "Daro/Quantity/PostController", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  DeleteController(id:number,Token:String):Observable<QUANTITY_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/Quantity/DeleteController?id=" + id
      + "&token=" + Token).pipe(
      map(data=>{
        return data as QUANTITY_Interface
      })
    )
}

}
